import React from 'react';
import GoogleAd from './GoogleAd';
import { AD_SLOTS } from './adConfig';

/**
 * A responsive in-content ad, intended to be dropped between sections of a long page
 * (e.g. between the stats panel and the events list on the home page).
 *
 * Unlike the top banner, this one shows on all widths, so it captures impressions on wide
 * desktops too (where it complements the vertical side rails without overlapping content).
 */
export default function InContentAd() {
    return (
        <div className="metadb-incontent-ad">
            <GoogleAd
                slot={AD_SLOTS.inContent}
                format="auto"
                responsive={true}
                label="In-Content (responsive)"
                style={{ display: 'block' }}
            />
        </div>
    );
}
